import { render } from "./Suporte.vue?vue&type=template&id=1d8b12f2"
import script from "./Suporte.vue?vue&type=script&lang=js"
export * from "./Suporte.vue?vue&type=script&lang=js"

import "./Suporte.vue?vue&type=style&index=0&id=1d8b12f2&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__